import React from 'react';

import NavigationBar from './components/NavigationBar';
import Footer from './components/Footer';

import Banner from "./components/Banner";
import ChurchLocation from "./components/ChurchLocation";
import Sermons from "./components/Sermons";
import BodyText from "./components/BodyText";
import Navigator from "./components/Navigator";
import StaffSection from "./components/StaffSection";
import StripePayment from "./components/StripePayment";

class page extends React.Component{
    constructor(props) {
        super(props);

        this.state = {
            title: props.fields.pageTitle,
            primeColor: props.fields.primaryColor,
            secondColor: props.fields.secondaryColor,
            sections: props.fields.sections,
            navigationBar: props.fields.navigationBar,
            footer: props.fields.footer
        }
    }

    componentDidMount(){
        document.title = this.state.title;
    }

    render(){
        return (
            <div className="container-fluid page-container">
                { /// NAVIGATION BAR ///
                    <NavigationBar fields={this.state.navigationBar.fields} primeColor={this.state.primeColor} secondColor={this.state.secondColor}/>
                }

                { /// PAGE SECTIONS ///
                    this.state.sections.map((section, i) => {
                        switch(section.sys.contentType.sys.id){
                            case "banner":
                                return <Banner fields={section.fields}/>
                            break;

                            case "churchLocation":
                                return <ChurchLocation fields={section.fields} primeColor={this.state.primeColor}/>
                            break;

                            case "sermons":
                                return <Sermons fields={section.fields} primeColor={this.state.primeColor}/>
                            break;

                            case "bodyText":
                                return <BodyText fields={section.fields}/>
                            break;

                            case "navigator":
                                return <Navigator fields={section.fields}/>
                            break;

                            case "staffSection":
                                return <StaffSection fields={section.fields}/>
                            break;

                            case "stripePayment":
                                return <StripePayment fields={section.fields}/>
                            break;
                        }
                    })
                }

                { /// FOOTER ///
                    <Footer fields={this.state.footer.fields}/>
                }
            </div>
        );
    }
}

export default page;
